<template>
  <v-dialog width="1200" v-model="showMilestoneForm" persistent scrollable>
    <v-card class="milestone-dialog" elevation="12">
      <v-card-title class="primary white--text pa-6 elevation-2">
        <div class="d-flex align-center">
          <v-icon class="mr-3" size="28">mdi-flag-checkered</v-icon>
          <div>
            <h2 class="text-h5 font-weight-medium mb-1">
              {{ editMode ? "Update" : "Add New" }} Milestone
            </h2>
          </div>
        </div>

        <v-spacer></v-spacer>

        <v-btn
          icon
          large
          @click="resetForm(), (showMilestoneForm = false)"
          class="hover-close-btn"
        >
          <v-icon class="white--text" size="24">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Enhanced Content Area -->
      <v-card-text class="pa-6">
        <v-form ref="milestoneForm" v-if="showMilestoneForm" v-model="isValid">
          <!-- Basic Information Section -->
          <div class="mb-6">
            <div class="section-header mb-4">
              <v-icon class="mr-2" color="primary"
                >mdi-information-outline</v-icon
              >
              <h3 class="text-h6 primary--text font-weight-medium">
                Basic Information
              </h3>
            </div>

            <v-row class="form-row">
              <!-- <v-col cols="12" md="4" class="form-column">
                <div class="input-wrapper">
                  <MultiSelect
                    label="Job Type *"
                    :items="allJobTypeList"
                    itemText="display_name"
                    itemValue="value"
                    hide-details="auto"
                    :rules="[(val) => !!val || 'Job Type is required!']"
                    v-model="milestoneDetails.job_type"
                    :error-messages="formErrors.job_type"
                    @input="delete formErrors.job_type"
                    outlined
                    dense
                    class="rounded-input"
                  >
                  </MultiSelect>
                </div>
              </v-col> -->

              <v-col cols="12" md="4" class="form-column">
                <div class="input-wrapper">
                  <InputField
                    type="text"
                    label="Milestone Name *"
                    required
                    :rules="[(val) => !!val || 'Milestone Name is required!']"
                    hide-details="auto"
                    v-model="milestoneDetails.milestone_name"
                    :error-messages="formErrors.milestone_name"
                    :disabled="milestoneDetails.milestone_type === 'System'"
                    @input="delete formErrors.milestone_name"
                    outlined
                    dense
                    class="rounded-input"
                  >
                  </InputField>
                </div>
              </v-col>
           
              <v-col  v-if="milestoneDetails.milestone_type === 'System'" cols="12" md="4" class="form-column" >
                <div class="input-wrapper">
                  <InputField
                    type="number"
                    label="Radius (in Meter)"
                    hide-details="auto"
                    v-model="milestoneDetails.radius"
                    :error-messages="formErrors.radius"
                    @input="delete formErrors.radius"
                    outlined
                    dense
                    class="rounded-input"
                  >
                  </InputField>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="form-column" v-if="milestoneDetails.milestone_type != 'System'">
                <div class="input-wrapper">
                  <MultiSelect
                    label="Geofence"
                    :items="geoFenceList"
                    itemText="name"
                    itemValue="id"
                    hide-details="auto"
                    v-model="milestoneDetails.geofence"
                    :error-messages="formErrors.geofence"
                    @input="delete formErrors.geofence"
                    outlined
                    dense
                    class="rounded-input"
                  >
                  </MultiSelect>
                </div>
              </v-col>
             
              <v-col cols="12" md="4" class="form-column" v-if="milestoneDetails.milestone_type != 'System'">
                <div class="input-wrapper">
                  <MultiSelect
                    label="Trigger Type"
                    :items="triggerTypeList"
                    itemText="label"
                    itemValue="value"
                    hide-details="auto"
                    v-model="milestoneDetails.trigger_type"
                    :error-messages="formErrors.trigger_type"
                    @input="delete formErrors.trigger_type"
                    outlined
                    dense
                    class="rounded-input"
                  >
                  </MultiSelect>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-divider class="mx-0"></v-divider>

      <!-- Enhanced Actions -->
      <v-card-actions class="pa-6 grey lighten-5">
        <v-spacer></v-spacer>

        <div class="d-flex align-center">
          <v-btn
            v-if="!editMode"
            color="grey darken-1"
            outlined
            class="mr-3 action-btn"
            @click="resetForm"
          >
            <v-icon left>mdi-refresh</v-icon>
            Reset Form
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!isValid"
            @click="submitForm"
            class="action-btn elevation-2"
          >
            <v-icon left>{{
              editMode ? "mdi-content-save" : "mdi-plus-circle"
            }}</v-icon>
            {{ editMode ? "Update Milestone" : "Create Milestone" }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";
import GoogleMap from "@/components/General/GoogleMap.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
    GoogleMap,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editMilestoneID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getMilestoneOptions();
        this.getLSGeoFenceList();
        if (this.editMode) {
          this.getMilestoneObject(this.editMilestoneID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showMilestoneForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      isValid: true,
      isTextInput: false,
      allJobTypeList: [],
      geoFenceList: [],
      milestoneDetails: {},
      triggerTypeList: [
        { value: "Entry", label: "Entry" },
        { value: "Exit", label: "Exit" },
        { value: "Not Applicable", label: "Not Applicable" },
      ],
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);

      if (!this.editMode) {
        this.milestoneDetails = {
          ...this.milestoneDetails,
        };
        this.$api.milestone
          .addMilestone(this.milestoneDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Milestone added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showMilestoneForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add milestone!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        let payload = {
          ...this.milestoneDetails,
        };
        this.$api.milestone
          .updateMilestone({
            id: this.milestoneDetails.id,
            data: payload,
          })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Milestone updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showMilestoneForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update milestone!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    getMilestoneOptions() {
      this.$bus.$emit("showLoader", true);
      this.$api.milestone
        .getMilestoneOptions()
        .then((res) => {
          this.allJobTypeList = res.data.actions.POST.job_type.choices;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getLSGeoFenceList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      this.$api.gpsIntegration
        .geofenceList(params)
        .then((res) => {
          this.geoFenceList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    resetForm() {
      if (this.$refs.milestoneForm) {
        this.$refs.milestoneForm.reset();
      }
      this.milestoneDetails = {};
    },

    getMilestoneObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.milestone
        .getMilestoneObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.milestoneDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style scoped>
.milestone-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #f5f5f5;
}

.form-row {
  margin: 0 -8px;
}

.form-column {
  padding: 8px !important;
}

.input-wrapper {
  position: relative;
}

.rounded-input {
  border-radius: 8px;
}

.rounded-input >>> .v-input__control .v-input__slot {
  border-radius: 8px !important;
}

.switch-card {
  border-radius: 8px;
  background: rgba(var(--v-primary-base), 0.02);
  border: 1px solid rgba(var(--v-primary-base), 0.12);
  transition: all 0.3s ease;
}

.switch-card:hover {
  background: rgba(var(--v-primary-base), 0.04);
  border-color: rgba(var(--v-primary-base), 0.2);
}

.geofence-section {
  margin-top: 24px;
  padding: 20px;
  background: linear-gradient(
    135deg,
    rgba(76, 175, 80, 0.02) 0%,
    rgba(139, 195, 74, 0.02) 100%
  );
  border-radius: 12px;
  border: 1px solid rgba(76, 175, 80, 0.1);
}

.map-container {
  border-radius: 12px;
  overflow: hidden;
  background: white;
}

.map-wrapper {
  position: relative;
  overflow: hidden;
}

.action-btn {
  min-width: 120px;
  height: 40px;
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
}

.hover-close-btn {
  transition: all 0.3s ease;
}

.hover-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(90deg);
}

.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
  transition: all 0.3s ease-in-out;
}

@media (max-width: 768px) {
  .milestone-dialog {
    margin: 16px;
    max-height: calc(100vh - 32px);
  }

  .form-row {
    margin: 0;
  }

  .form-column {
    padding: 4px !important;
  }

  .action-btn {
    min-width: 100px;
    font-size: 14px;
  }
}

.rounded-input >>> .v-input--is-focused .v-input__slot {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-primary-base), 0.1);
}

.action-btn.v-btn--loading {
  pointer-events: none;
}
</style>
